export const ASSET_TYPE_VIDEO = 'video';
export const ASSET_TYPE_IMAGE = 'image';
